import React from 'react'

import Participant from './Participant'
import { Container } from './styles'

import useParticipantsContext from '../../context/useCreateContext'

const Participants = () => {
    const { filteredParticipants } = useParticipantsContext()

    return (
        <Container>
            {filteredParticipants?.map(participant => {
                return (
                    <Participant
                        key={`pl-${participant.id}`}
                        participant={participant}
                    />
                )
            })}
        </Container>
    )
}

export default Participants
